import React, { useContext, useEffect, useState } from 'react'
import { getWpMedia } from '../../api/api_wp'
import { firestore } from '../../firebase'
import StateContext from '../../StateContext'
import Loader from '../Loader/Loader'
import AddMedia from './templates/AddMedia'
import WpMediaListTemplate from './templates/WpMediaListTemplate'

function WpMedia({baseUrl}) {

    const {loggedIn} = useContext(StateContext)

    const [fbMedia, setFbMedia] = useState([])

    const [media, setMedia] = useState([])
    const [images, setImages] = useState([])
    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(9)
    const [baseUrlWp, setBaseUrlWp] = useState("https://progitek.no/privat/bp/")

    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {

        try {
            const imagesRef = firestore.collection("images");
            imagesRef.orderBy("createdAt", "desc").onSnapshot(({docs}) => {
                const fbMedia = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setFbMedia(fbMedia)
            })
            
        } catch (error) {
            
        }

    }, [])

    useEffect(() => {

        async function getWpMediaData() {
            setIsLoading(true)

            const data = await getWpMedia(baseUrlWp, perPage, page)
            if (data?.length > 0) {
                const images = data?.filter(media => media.media_type === "image");
            }
            let mediaToAdd 
            if (page === 1) {
                mediaToAdd = data
            } else {
                mediaToAdd = media.concat(data)
            }

            setMedia(mediaToAdd)
            setIsLoading(false)
        }
        getWpMediaData()

    }, [page, perPage, baseUrlWp])

    function loadMoreHandler() {
        setPage(page => page+1)
    }

    function resetMedia() {
        setMedia([])
        setPerPage(10)
        setPage(1)
    }

    const BASE_URLS = [
        {
            name: "Progitek",
            baseUrl: "https://progitek.no/"
        },
        {
            name: "Sosial",
            baseUrl: "https://progitek.no/privat/bp/"
        },
        {
            name: "Smorasstats",
            baseUrl: "https://smorasstats.com/v4/"
        },
    ]

    return (
        <div>
            {loggedIn && <AddMedia />}

            <div className="row my-2">
                {BASE_URLS.map((url, index) => {
                    return (
                        <div className="col-4" key={index}>
                            <button onClick={() => setBaseUrlWp(url.baseUrl)} className={`btn btn-block ${url.baseUrl === baseUrlWp ? "btn-success" : "btn-primary"}`}>{url.name}</button>
                        </div>
                    )
                })}
            </div>
            <div className="my-3">
                <button onClick={resetMedia} className="btn btn-danger btn-block">Reset <i className="fas fa-redo-alt"></i></button>
            </div>
            <label>Velg antall bilder ({perPage})</label>
            <select className="browser-default custom-select" onChange={e => setPerPage(e.target.value)}>
                <option value="10">10</option>
                <option value="50">50</option>
                <option value="100">100</option>
            </select>

            {isLoading && page === 1 && (
                    <div className="my-3"><Loader /></div>
            )}

            <div className="row no-gutters">

                {media?.map((image, index) => {
                    return <WpMediaListTemplate key={index} image={image} fbMedia={fbMedia} />
                })}
                {isLoading && page !== 1 && (
                    <div className="col-12 my-3"><Loader /></div>
                ) }
                {!isLoading && (
                    <div className="col-12">
                        <button className="btn btn-block btn-primary" onClick={loadMoreHandler}>Last mer</button>
                    </div>
                )}
            </div>
        </div>

    )

}
export default WpMedia